import { v4 as uuidv4 } from 'uuid'
import { HttpClient, serializeJSONApiData } from '@opallabs/api'
import { getNestedProperty } from '@opallabs/lambda'
import createWorkflowPhaseItem from '../createWorkflowPhaseItem'
import loadWorkflow from '../loadWorkflow'

// default payload data for a new Task
const newTask = () => ({
  request: 'Task',
  type: 'tasks',
  uuid: uuidv4(),
})

const postWorkflowPhase = ({ identifier, params, type, workflowId }) =>
  HttpClient().post(
    `/api/v1/${
      type && identifier ? `${type}/${identifier}/` : ''
    }workflow/${workflowId}/phases`,
    { data: params.data }
  )

const createWorkflowPhase =
  ({ identifier, newPhase, type = 'content', workflowId }) =>
  (dispatch) => {
    const params = serializeJSONApiData('approval-phases', newPhase, true)

    return postWorkflowPhase({ identifier, params, type, workflowId })
      .then((response) => {
        const resAttrs = getNestedProperty(
          response,
          'data',
          'data',
          'attributes'
        )
        const phaseType = resAttrs.phase_type
        const phaseId = resAttrs.id

        // new Task Phases must have at least one Task, so we need to create one immediately
        if (phaseType === 'task' && phaseId) {
          return dispatch(
            createWorkflowPhaseItem({
              identifier,
              phaseId,
              type,
              update: newTask(),
              workflowId,
            })
          )
        }

        return dispatch(loadWorkflow(response.data))
      })
      .catch((err) => {
        console.log(err)
        throw err
      })
  }

export default createWorkflowPhase
